import { render, staticRenderFns } from "./MeusConcursosFavoritosPerfil.vue?vue&type=template&id=64ca49c6&scoped=true&"
import script from "./MeusConcursosFavoritosPerfil.vue?vue&type=script&lang=js&"
export * from "./MeusConcursosFavoritosPerfil.vue?vue&type=script&lang=js&"
import style0 from "./MeusConcursosFavoritosPerfil.vue?vue&type=style&index=0&id=64ca49c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca49c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VIcon,VRow})
